const styles = () => ({
  logo: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: '0 0 100%',
  },
});

export default styles;
